import { Form, FormikProvider, useFormik } from "formik"
import React, { ReactNode, useState } from "react";
import { Button } from "ui-components/src/Button";
import { FormField } from "ui-components/src/FormField";
import { yup } from "ui-components/src/yup";
import { v1 } from "../../../endpoints/src/v1";
type IResetPasswordForm = { email: string };
import styles from './styles.module.scss';

export const ResetPasswordPage: React.FC = () => {
  const [genericError, setGenericError] = useState<string>();
  const [success, setSuccess] = useState(false);

  const form = useFormik({
    validateOnBlur: true,
    validateOnChange: true,
    initialValues: {
      email: ''
    },
    validationSchema: yup
      .object()
      .shape({
        email: yup
          .string()
          .required(
            "Enter a valid email."
          )
          .email(
            "Enter a valid email."
          ),
      }),
    onSubmit: async values => {
      try {
        const res = await fetch(v1.resetPassword, {
          method: 'POST',
          body: JSON.stringify(values),
          headers: {
            'Content-Type': 'application/json'
          }
        });

        const body: { status: number, message: string, error?: string } = await res.json();

        if (res.status === 201) {
          setSuccess(true);
        } else {
          if (res.status === 404) {
            setGenericError("We couldn't find an account with this email address.");

            return;
          }

          if (res.status !== 500) {
            setGenericError(body.message || body.error || 'An unknown error occurred. Please try again later.');

            return;
          }

          setGenericError(body.message || body.error || 'An unknown error occurred. Please try again later.');
        }
      } catch (e) {
        setGenericError('An unknown error occurred. Please try again later.');
      }
    }
  });

  return (
    <div
      className={styles.container}
    >
      <FormikProvider
        value={form}
      >
        {!success && <Form>
          <p>Please enter the email address for the account you wish to reset</p>
          <ResetPasswordFormField
            label="Email"
            fieldName="email"
          />

          {genericError && (
            <ResetPasswordFormError>
              {genericError}
            </ResetPasswordFormError>
          )}

          <Button
            type="submit"
            indicateProgress={form.isSubmitting}
            disabled={form.isSubmitting}
            className="button-blue"
          >
            Reset
          </Button>
        </Form>}
        {success && <div
          className={styles.success}
        >
          <h2>We've sent an email with password reset instructions.</h2>
          <p>If you do not receive an email within a few minutes, please check your spam folder and email security settings.</p>
          <p><strong>School spam filters often block password reset emails.</strong> <a href="http://support.kodable.com/troubleshooting/i-am-not-receiving-kodable-emails" target="_blank">Click here to learn how to fix this.</a></p>
        </div>}
      </FormikProvider>
    </div>
  );
}

const ResetPasswordFormField = FormField<IResetPasswordForm>();

const ResetPasswordFormError: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div
      className={styles.error}
    >
      {children}
    </div>
  )
}